import { IRawStyle, mergeStyles } from "@fluentui/react";
import { FluentIconsProps } from "@fluentui/react-icons";
import { RaisedHandIconAsset } from "./RaisedHandIconAsset";
import React, { ReactNode, useMemo } from "react";

interface RaisedHandIconProps {
    children?: ReactNode;
    styles?: RaisedHandIconStyles;
}

interface RaisedHandIconStyles {
    root?: IRawStyle;
    container?: IRawStyle;
}

const raisedHandIconStyles = () => ({
    root: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",  //SVG horizontal align
        '--raise-hand-icon-size': `24px`,   //default value, can be overriten by "styles" property of RaisedHandIconProps

        width: "var(--raise-hand-icon-size)",
        height: "var(--raise-hand-icon-size)",
    } as IRawStyle,


    container: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        '--raise-hand-icon-container-size': `16px`,    //default value, can be overriten by "styles" property of RaisedHandIconProps

        width: "var(--raise-hand-icon-container-size)",
        height: "var(--raise-hand-icon-container-size)",
    } as IRawStyle,

    svgIcon: {
        maxWidth: "100%",
        maxHeight: "100%",
    },
});


/**
 * Raised hand icon for ParticipantList.
 *
 * @public
 */
export const RaisedHandIcon = (props: RaisedHandIconProps): JSX.Element => {

    const { children } = props;
    const styles = raisedHandIconStyles();

    const icon = useMemo(() => {
        const iconProps: FluentIconsProps = {
            className: mergeStyles(styles.svgIcon),
        };

        return (
            <RaisedHandIconAsset {...iconProps} />
        );
    }, [styles.svgIcon]);
    return (
        <div className={mergeStyles(styles.root, props.styles?.root ?? {})}>
            <div className={mergeStyles(styles.container, props.styles?.container)}>
                {children ? children : undefined}
                {icon}
            </div>

        </div>
    );
}
